import { BaseApiService } from '@/services/base-service';
import { ResponseStatuses } from '@/enums';
import { BaseResponse, Response } from '@/types';
import Vue from 'vue';
import { User } from '../types';

export const default_user = (): User.Profile => ({
  name: '',
  surname: '',
  patronymic: '',
  company: '',
  is_shipping_stopped: null,
  telephone: '',
  email: '',
  birth_date: '',
  city: '',
  password: '',
  partner_code: '',
  sigma_partner_code: null,
  frontol_partner_code: null,
  job_rank: null,
  roles: [],
  widgets: [],
  available_pages: [],
  io_user: '',
  io_company: '',
  main_menu: [],
  last_news: null,
  constants: {
    const_max_cart_product_quantity_per_unit: 0,
  },
  is_resident: false,
  is_authorized: false,
  is_admin: false,
  today_events: null,
});

const res: Response<string> = {
  data: '',
  code: 123,
  success: true,
};

export class UserService extends BaseApiService {
  private base_path = 'user/me';

  async get_own_profile(): Promise<Response<User.Profile>> {
    const res = await this.http_client.get<Response<User.Profile>>(this.base_path);

    if (res.status === ResponseStatuses.Success.RESET_CONTENT) {
      // const { data } = await this.http_client.get<Response<User.Profile>>(this.base_path);

      // return data;

      window.location.reload();
    }
    return res.data;
  }

  async update_user_info(user: User.Profile): Promise<boolean> {
    const { data } = await this.http_client.patch<Response<User.Profile>>(
      `${this.base_path}`,
      user,
    );

    return data.success;
  }

  async update_user_avatar(avatar: File): Promise<Response<Record<'path', string>>> {
    const form_data = new FormData();

    form_data.append('avatar', avatar);

    const { data } = await this.http_client.post<Response<Record<'path', string>>>(
      `${this.base_path}/photo`,
      form_data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return data;
  }

  async update_password(data: User.PasswordApiUpdate): Promise<void> {
    await this.http_client.patch(`${this.base_path}/password`, data);
  }

  async send_email(email: string): Promise<void> {
    await this.http_client.patch(`${this.base_path}/email`, { email });
  }

  async send_email_validation_code(data: User.EmailValidationCodeApi): Promise<void> {
    await this.http_client.post(`${this.base_path}/email/code`, data);
  }

  async add_to_favorites(id: number): Promise<void> {
    await this.http_client.post(`page/${id}/favorite`);
  }

  async remove_from_favorites(id: number): Promise<void> {
    await this.http_client.delete(`page/${id}/favorite`);
  }
}
